<template>
  <div>
    <Header />
    <v-img
      :src="require('@/assets/bannerProvUbicacion.jpg')"
      :lazy-src="require('@/assets/carruselLazyLoad.jpg')"
      aspect-ratio="3.65"
      contain
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>

    <v-row align="center" justify="center" no-gutters>
      <v-breadcrumbs :items="itemsBreadCrumbs" large>
        <template v-slot:divider>
          <v-icon>mdi-forward</v-icon>
        </template>
      </v-breadcrumbs>
    </v-row>

    <v-col cols="12" class="pt-5">
      <v-row align="center" justify="center">
        <v-card
          class="ma-3 pa-6"
          style="border: 0px solid white"
          width="700"
          outlined
          tile
        >
          <p
            class="subfont text-justify text-center mb-0"
            :class="[
              $vuetify.breakpoint.mdAndUp ? 'subfont' : 'subfontResponsive',
            ]"
          >
            Amplia red de proveedores estrátegicamente ubicados en las
            principales ciudades y carreteras de tráfico internacional que se
            traduce en tiempos de respuesta cortas.
          </p>
        </v-card>
      </v-row>
    </v-col>

    <v-container>
      <v-row class="d-flex justify-space-around">
        <v-col cols="12" md="4">
          <div
            id="mapContainer"
            class="mx-auto"
            style="max-width:750px; height: 550px"
          ></div>
        </v-col>

        <v-col cols="12" md="4">
          <v-card max-width="375" class="mx-auto">
            <v-card-title
              class="text-xl-h4 pt-1"
              :class="[
                $vuetify.breakpoint.mdAndUp
                  ? 'fontTitulo'
                  : 'fontTituloResponsive',
              ]"
              >CON PRESENCIA EN:</v-card-title
            >
            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>FRONTERA LA HACHADURA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(1)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>CHIQUIMULILLA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(2)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>ESCUINTLA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(3)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    >SANTA LUCIA CUTUZULMAGUAPA</v-list-item-title
                  >
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(4)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>MAZATENANGO</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(5)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>RETALHULEO</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(6)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>FRONTERA TECUN UMA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(7)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>QUEZALTENANGO</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(8)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>XELA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(8)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>HUEHUETENANGO</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(9)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SANTA CRUZ DEL QUICHE</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(10)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>ANTIGUA GUATEMALA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(11)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>CHIMALTENANGO</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(12)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>CIUDAD DE CUATEMALA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(13)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card max-width="375" class="mx-auto">
            <v-card-title
              class="text-xl-h4 pt-1"
              :class="[
                $vuetify.breakpoint.mdAndUp
                  ? 'fontTitulo'
                  : 'fontTituloResponsive',
              ]"
              >CON PRESENCIA EN:</v-card-title
            >
            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>CUILAPA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(14)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>JUTIAPA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(15)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>FRONTERA LAS CHINAMAS</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(16)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>FRONTERA SAN CRISTOBAL</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(17)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>FRONTERA ANGUIATUD</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(18)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>ESQUIPULAS</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(19)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>CHIQUIMULA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(20)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>ZACAPA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(21)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>RIO HONDO</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(22)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>GUALAN</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(23)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>MORALES</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(24)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>PUERTO BARRIOS</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(25)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    >PUERTO SANTO TOMAS DE CASTILLA</v-list-item-title
                  >
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(26)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>PETEN</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(27)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <ButtonScroll />
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import ButtonScroll from "../components/ButtonScroll.vue";
import mapboxgl from "mapbox-gl";

export default {
  components: {
    Header,
    Footer,
    ButtonScroll,
  },
  data: () => ({
    markers: [
      {
        id: 1,
        name: "FRONTERA LA HACHADURA",
        position: [-90.086926, 13.859496],
      },
      {
        id: 2,
        name: "CHIQUIMULILLA",
        position: [-90.380043, 14.082222],
      },
      {
        id: 3,
        name: "ESCUINTLA",
        position: [-91.054969, 14.146043],
      },
      {
        id: 4,
        name: "SANTA LUCIA CUTUZULMAGUAPA",
        position: [-91.025076, 14.335824],
      },
      {
        id: 5,
        name: "MAZATENANGO",
        position: [-91.507295, 14.531721],
      },
      {
        id: 6,
        name: "RETALHULEO",
        position: [-91.680264, 14.535855],
      },
      {
        id: 7,
        name: "FRONTERA TECUN UMA",
        position: [-92.14545, 14.676236],
      },
      {
        id: 8,
        name: "QUEZALTENANGO",
        position: [-91.523743, 14.844695],
      },
      {
        id: 9,
        name: "HUEHUETENANGO",
        position: [-91.470147, 15.320515],
      },
      {
        id: 10,
        name: "SANTA CRUZ DEL QUICHE",
        position: [-91.14929, 15.026195],
      },
      {
        id: 11,
        name: "ANTIGUA GUATEMALA",
        position: [-90.733477, 14.557731],
      },
      {
        id: 12,
        name: "CHIMALTENANGO",
        position: [-90.822278, 14.658881],
      },
      {
        id: 13,
        name: "CIUDAD DE CUATEMALA",
        position: [-90.51007, 14.632848],
      },
      {
        id: 14,
        name: "CUILAPA",
        position: [-90.299463, 14.276694],
      },
      {
        id: 15,
        name: "JUTIAPA",
        position: [-89.834684, 14.292297],
      },
      {
        id: 16,
        name: "FRONTERA LAS CHINAMAS",
        position: [-89.900423, 14.018812],
      },
      {
        id: 17,
        name: "FRONTERA SAN CRISTOBAL",
        position: [-89.667291, 14.186628],
      },
      {
        id: 18,
        name: "FRONTERA ANGUIATUD",
        position: [-89.433441, 14.411386],
      },
      {
        id: 19,
        name: "ESQUIPULAS",
        position: [-89.34669, 14.565365],
      },
      {
        id: 20,
        name: "CHIQUIMULA",
        position: [-89.544552, 14.800486],
      },
      {
        id: 21,
        name: "ZACAPA",
        position: [89.531159, 14.97246],
      },
      {
        id: 22,
        name: "RIO HONDO",
        position: [-89.589696, 15.042041],
      },
      {
        id: 23,
        name: "GUALAN	",
        position: [-89.356227, 15.114427],
      },
      {
        id: 24,
        name: "MORALES",
        position: [-88.84326, 15.471093],
      },
      {
        id: 25,
        name: "PUERTO BARRIOS	",
        position: [-88.586752, 15.696981],
      },
      {
        id: 26,
        name: "PUERTO SANTO TOMAS DE CASTILLA",
        position: [-88.617403, 15.695261],
      },
      {
        id: 27,
        name: "PETEN",
        position: [-90.046456, 16.965116],
      },
    ],
    itemsBreadCrumbs: [
      {
        text: "HOME",
        disabled: false,
        href: "/",
      },
      {
        text: "NUESTROS PROVEEDORES GUATEMALA",
        disabled: true,
        href: "",
      },
    ],
    map: "",
    accessToken:
      "pk.eyJ1Ijoiam9obmxpbmFyZXMiLCJhIjoiY2tjcWk2eDZrMTU2bjJyczVyMWF0ejg3NiJ9.848u9JaZDYfKTRPBzFvDwA",
  }),

  mounted() {
    mapboxgl.accessToken = this.accessToken;
    this.map = new mapboxgl.Map({
      container: "mapContainer",
      style: "mapbox://styles/mapbox/streets-v11",
      center: [-90.230759, 15.783471],
      zoom: 6,
    });
    for (var i = 0; i < this.markers.length; i++) {
      var marker = new mapboxgl.Marker({ color: "blue" })
        .setLngLat(this.markers[i].position)
        .setPopup(
          new mapboxgl.Popup({ offset: 25 }).setHTML(
            "<strong>" + this.markers[i].name + "</strong>"
          )
        )
        .addTo(this.map);
    }
    this.map.addControl(new mapboxgl.FullscreenControl());
    this.map.addControl(
      new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
        },
        trackUserLocation: true,
      })
    );
    this.map.addControl(new mapboxgl.NavigationControl());
  },

  methods: {
    Flyto(i) {
      switch (i) {
        case 1:
          var center = this.markers[i - 1].position;
          break;
        case 2:
          var center = this.markers[i - 1].position;
          break;
        case 3:
          var center = this.markers[i - 1].position;
          break;
        case 4:
          var center = this.markers[i - 1].position;
          break;
        case 5:
          var center = this.markers[i - 1].position;
          break;
        case 6:
          var center = this.markers[i - 1].position;
          break;
        case 7:
          var center = this.markers[i - 1].position;
          break;
        case 8:
          var center = this.markers[i - 1].position;
          break;
        case 9:
          var center = this.markers[i - 1].position;
          break;
        case 10:
          var center = this.markers[i - 1].position;
          break;
        case 11:
          var center = this.markers[i - 1].position;
          break;
        case 12:
          var center = this.markers[i - 1].position;
          break;
        case 13:
          var center = this.markers[i - 1].position;
          break;
        case 14:
          var center = this.markers[i - 1].position;
          break;
        case 15:
          var center = this.markers[i - 1].position;
          break;
        case 16:
          var center = this.markers[i - 1].position;
          break;
        case 17:
          var center = this.markers[i - 1].position;
          break;
        case 18:
          var center = this.markers[i - 1].position;
          break;
        case 19:
          var center = this.markers[i - 1].position;
          break;
        case 20:
          var center = this.markers[i - 1].position;
          break;
        case 21:
          var center = this.markers[i - 1].position;
          break;
        case 22:
          var center = this.markers[i - 1].position;
          break;
        case 23:
          var center = this.markers[i - 1].position;
          break;
        case 24:
          var center = this.markers[i - 1].position;
          break;
        case 25:
          var center = this.markers[i - 1].position;
          break;
        case 26:
          var center = this.markers[i - 1].position;
          break;
        case 27:
          var center = this.markers[i - 1].position;
          break;
      }
      this.map.flyTo({
        center: center,
        zoom: 13,
        bearing: 0,
        speed: 0.5,
        curve: 1,
        easing: function(t) {
          return t;
        },
        essential: true,
      });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Zilla+Slab:ital,wght@1,700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=EB+Garamond:wght@500&family=Zilla+Slab:ital,wght@1,700&display=swap");

.subfont {
  font-family: "EB Garamond", serif;
  font-size: 25px;
}
.subfontResponsive {
  font-family: "EB Garamond", serif;
  font-size: 15px;
}
</style>
